"use client";

import { IconDotGrid1x3HorizontalTight } from "@central-icons-react/round-outlined-radius-3-stroke-2";
import * as React from "react";
import { Trash2 } from "lucide-react";

import { apiSend } from "@/lib/api/client";
import { deleteTaskContract } from "@/lib/api/contracts/tasks";
import {
  PopoverMenu,
  PopoverMenuItem,
  PopoverMenuSection,
} from "@/components/ui/popover-menu";
import { cn } from "@/lib/utils";

import { TaskChip } from "./task-chip";

type Props = {
  taskId: string;
  onDeleted?: () => void;
  className?: string;
};

export function TaskMoreMenu({ taskId, onDeleted, className }: Props) {
  const [open, setOpen] = React.useState(false);
  const [isPending, startTransition] = React.useTransition();

  const remove = () => {
    startTransition(async () => {
      const result = await apiSend(deleteTaskContract, {
        params: { id: taskId },
      });
      setOpen(false);
      if (result.ok) onDeleted?.();
    });
  };

  return (
    <PopoverMenu
      open={open}
      onOpenChange={setOpen}
      trigger={
        <TaskChip
          aria-label="Task actions"
          className={cn(
            "size-5 shrink-0 justify-center p-0 pl-0 pr-0 leading-none shadow-none",
            className,
          )}
        >
          <IconDotGrid1x3HorizontalTight
            size={12}
            className="text-neutral-07"
            aria-hidden
          />
        </TaskChip>
      }
      menuContentClassName="w-[9rem]"
      menu={
        <PopoverMenuSection>
          <PopoverMenuItem
            variant="destructive"
            icon={<Trash2 className="size-4" strokeWidth={1.5} />}
            label="Delete"
            disabled={isPending}
            onClick={remove}
          />
        </PopoverMenuSection>
      }
    />
  );
}
